import { put, takeLatest, select } from 'redux-saga/effects'
import * as Eff from 'redux-saga/effects' // tslint:disable-line:no-duplicate-imports
import toastr from 'toastr'

import Logger from '@Utils/Logger'
import getUrlWithAccountandWorkspace from '@Utils/GetUrlWithAccountAndWorkspace'
import { IAction } from '@Root/types'

import {
  importSrtSuccess,
  importSrtFailure,
  deleteLanguageSuccess,
  deleteLanguageFailure,
} from './actions'

import {
  closeDashboardPopups
} from '@SiteModules/Popup/actions'

import {
  IImportSrtPayload,
  SubtitleActionTypes,
  IDeleteLanguagePayload,
} from './types'

import * as API from './api'

const call: any = Eff.call

const DELAY_UNTIL_SUBTITLE_STATUS_IS_UPDATED_IN_DATABASE = 2000 // msec

const cleanLocalStorage = (subtitleId: number) => {
  // we're saving last user's changes to localStorage
  // we should remove them to load exactly the imported srt
  const prefix = `subtitle-${subtitleId}`

  window.localStorage.removeItem(`${prefix}-cues`)
  window.localStorage.removeItem(`${prefix}-synchronized`)
  window.localStorage.removeItem(`${prefix}-updated-at`)
}

function* importSrtSaga(action: IAction<IImportSrtPayload>): Generator<any, any, any> {
  try {
    const { payload } = action
    yield call(API.importSrt, payload)
    yield put(importSrtSuccess())
    if (payload) {
      cleanLocalStorage(payload.subtitleId)
    }
    yield put(closeDashboardPopups())
    toastr.success('', 'SRT file imported')

    const state = yield select()

    setTimeout(() => { window.location.href = getUrlWithAccountandWorkspace('/', state.accounts.currentAccountId, state.workspaces.currentWorkspaceId) }, DELAY_UNTIL_SUBTITLE_STATUS_IS_UPDATED_IN_DATABASE)
  } catch (e) {
    Logger.error(e, 'SRT file could not be imported')
    yield put(importSrtFailure())
  }
}

function* deleteLanguageSaga(action: IAction<IDeleteLanguagePayload>) {
  try {
    yield call(API.deleteLanguage, action.payload)
    yield put(deleteLanguageSuccess(action.payload))
    toastr.success('', 'Language deleted')
  } catch (e) {
    Logger.error(e, 'Language could not be deleted')
    yield put(deleteLanguageFailure())
  }
}

function* subtitleSagas() {
  yield takeLatest(SubtitleActionTypes.IMPORT_SRT, importSrtSaga)
  yield takeLatest(SubtitleActionTypes.DELETE_LANGUAGE, deleteLanguageSaga)
}

export default subtitleSagas
